import { styled } from '@mui/material/styles';

export const DragLineExtractionContainer = styled('div')(() => ({}));
